<template>
  <span class="progress-circle">
    <svg
      id="svg"
      width="30"
      height="30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="circle1"
        r="15"
        cx="15"
        cy="15"
        fill="transparent"
      ></circle>
      <!-- stroke-dasharray="565.48" -->

      <circle
        id="bar"
        class="circle2"
        r="15"
        cx="15"
        cy="15"
        fill="transparent"
        stroke="#ccc"
        :stroke-dashoffset="dashOffset"
      ></circle>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    percentComplete: {
      type: Number,
      required: true
    }
  },
  computed: {
    dashOffset() {
      let p = this.percentComplete;
      let dashArray = 94;
      return dashArray - dashArray * (p / 100);
    }
  }
};
</script>

<style lang="stylus" scoped>
.progress-circle
  round(30)
  overflow hidden
  display inline-block
  svg
    transform rotate(180deg)
    .circle1
      stroke gray_3
      stroke-width 5px
    .circle2
      stroke blue_brand
      stroke-width 5px
      stroke-dasharray 94
      transition 0.5s ease-out-back stroke-dashoffset
  // border 3px solid green_1
</style>
